<span class="defaultStyleSnackAlert">
  {{data}}
</span>
